import { render, staticRenderFns } from "./PlayAreas.vue?vue&type=template&id=6f331b1b&"
import script from "./PlayAreas.vue?vue&type=script&lang=js&"
export * from "./PlayAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports